import React, { useEffect } from "react";
import { Grid, Card, CardContent, Typography, Box, Button } from "@mui/material";
import imgPostagem from "../../../assets/img/publiInstagram.jpg";
import imgPerfil from "../../../assets/img/perfiInsta.jpg";

const SocialMedia = () => {
  useEffect(() => {
    const loadFacebookSDK = () => {
      if (!window.FB) {
        const script = document.createElement("script");
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.async = true;
        script.defer = true;
        script.crossOrigin = "anonymous";
        script.onload = () => {
          window.FB?.init({
            appId: "YOUR_APP_ID",
            xfbml: true,
            version: "v12.0",
          });
          window.FB?.XFBML.parse();
        };
        document.body.appendChild(script);
      } else {
        window.FB.XFBML.parse();
      }
    };

    loadFacebookSDK();
  }, []);

  return (
    <Box sx={{ textAlign: "center", padding: "20px" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Redes Sociais
      </Typography>
      <Grid container spacing={3} justifyContent="center">

        {/* Instagram Card */}
        <Grid item xs={12} sm={6} md={6}>
          <Card sx={{ display: "flex", flexDirection: "column", padding: "20px", borderRadius: "10px", boxShadow: 3, height: "100%", width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%", padding: "10px", borderBottom: "1px solid #ddd" }}>
              <img src={imgPerfil} alt="Perfil" style={{ width: "40px", height: "40px", borderRadius: "50%", marginRight: "10px" }} />
              <Box sx={{ textAlign: "left" }}>
                <Typography variant="body1" fontWeight="bold">@camaraserracaiada</Typography>
                <Typography variant="body2" color="textSecondary">Câmara Municipal de Serra Caiada-RN</Typography>
              </Box>
            </Box>

            <Box sx={{ width: "100%", height: "315px", overflow: "hidden", borderRadius: "10px" }}>
              <img src={imgPostagem} alt="Postagem" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </Box>

            <CardContent sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-start", paddingTop: "10px" }}>
              <Typography variant="body2">
                <strong>649</strong> posts | <strong>1.5K</strong> followers | <strong>31</strong> following
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Canal oficial da Câmara Municipal de Serra Caiada/RN. O Legislativo perto do POVO!
              </Typography>
              <Button
                variant="contained"
                color="primary"
                href="https://www.instagram.com/p/DFp6anWptso/?igsh=YnJpZHZiZHNvZngw"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ marginTop: "10px" }}
              >
                Ver no Instagram
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Facebook Card */}
        <Grid item xs={12} sm={6} md={6}>
          <Card sx={{ display: "flex", flexDirection: "column", padding: "20px", borderRadius: "10px", boxShadow: 3, height: "100%", width: "100%" }}>
            <Box sx={{ width: "100%", height: "auto", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div
                className="fb-page"
                data-href="https://www.facebook.com/camaraserracaiada"
                data-tabs="timeline"
                data-width= "500"
                data-height="500"
                data-small-header="false"
                data-adapt-container-width="true"
                data-hide-cover="false"
                data-show-facepile="true"
                style={{
                  width: "100%",
                  maxWidth: "500px",  // Same maxWidth as the Instagram image
                  margin: "0 auto",
                  minHeight: "499px", // Ensure minimum height
                }}
              ></div>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SocialMedia;
